import React from "react";
import { wrap } from "./RydTestbedWrap";
import { RydChordSelector } from "../components/widgets/RydChordSelector";

function EurydiceChordSelectorTestbed() {
    return wrap(<>
        <h2>Chord selector testbed</h2>
        <RydChordSelector />
    </>);
}

export {
    EurydiceChordSelectorTestbed
};